import { FETCH_TRANSLATIONS_SUCCESS } from './translations-actions';
export function translationsReducer(state = {}, action) {
    switch (action.type) {
        case FETCH_TRANSLATIONS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
//# sourceMappingURL=translations-reducer.js.map